module.exports = __webpack_public_path__ + "static/media/co3.044376ba.jpg";